export const routes = {
  landingPage: '/',
  formPage: '/calculate',
  reportPage: '/report/:id',
  privacyPolicy: '/privacy-policy',
  termsOfUse: '/terms-of-use',
};
